// extracted by mini-css-extract-plugin
module.exports = {"info":"HeaderInfo_info__nvS0u"};